<template>
  <div class="register">
    <div class="register-box">
      <div class="register-head">
        <Head></Head>
      </div>
      <div class="register-main">
        <p class="wenxin">温馨提示：每次您访问本网站您必须登录以便结账和编辑您的账户信息。</p>
        <el-form
          :label-position="labelPosition"
          ref="numberValidateForm"
          :rules="rules"
          label-width="80px"
          :model="formData"
        >
          <el-form-item label="公司/单位" prop="company">
            <el-input id="keydown" v-model="formData.company"></el-input>
          </el-form-item>
          <!-- <el-form-item label="用户姓名" prop="username">
            <el-input id="keydown" v-model="formData.username"></el-input>
          </el-form-item> -->
          <el-form-item label="用户电话" prop="mobile">
            <el-input id="keydown" v-model="formData.mobile"></el-input>
          </el-form-item>
          <el-form-item label="用户邮箱" prop="email">
            <el-input v-model="formData.email"></el-input>
          </el-form-item>
          <!-- <el-form-item label="选择地区" prop="district">
            <el-cascader v-model="formData.district" :props="props" @change="handleChange" clearable></el-cascader>
          </el-form-item>
          <el-form-item label="详细地址" prop="address">
            <el-input v-model="formData.address"></el-input>
          </el-form-item> -->
          <el-form-item label="登录密码" prop="password">
            <el-input type="password" v-model="formData.password"></el-input>
          </el-form-item>
          <el-form-item label="密码确认" prop="checkPass">
            <el-input id="keydown" type="password" v-model="formData.checkPass"></el-input>
          </el-form-item>
        </el-form>
        <button
          v-bind:disabled="btnDisabled"
          :style="{cursor:(btnDisabled ? 'not-allowed' : 'pointer')}"
          class="register-btn"
          @click="submitForm('numberValidateForm')"
        >注册</button>
        <div class="bottom-text">
          <p>
            注册即表示知晓并同意、
            <span>《用户服务协议》</span>
            <span>《隐私政策》</span>和
            <span>《投稿须知》</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Head from "./components/registerhead";
import getUUID from "@/utils/getUUID";
export default {
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.formData.password) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      formData: {
        email: "",
        password: "",
        checkPass: "",
      //  captcha: "",
       // username: "",
        mobile: "",
        company: "",
        // address: "",
        // province_code: "",
        // city_code: "",
        // district_code: "",
        // district: [],
      },
      // props: {
      //   lazy: true,
      //   lazyLoad: this.cascaderDistrict
      // },
      btnDisabled: false,
      rules: {
        company: [
          { required: true, message: "请输入公司名称", trigger: "blur" }
        ],
       // username: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        //district: [{ required: true, message: "请选择地区",  trigger: 'change'  }],
        // address: [
        //   { required: true, message: "请输入详细地址", trigger: "blur" }
        // ],
        mobile: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
            message: "请输入正确的号码格式",
            trigger: ["blur", "change"]
          }
        ],
        email: [
          { required: true, message: "请输入邮箱地址", trigger: "blur" },
          {
            type: "email",
            message: "请输入正确的邮箱地址",
            trigger: ["blur", "change"]
          }
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            pattern: /^[^\s]{5,12}$/,
            message: "长度为5-12位，无空格",
            trigger: "change"
          }
        ],
        checkPass: [
          { required: true, message: "请再次输入密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" }
        ]
      },
      labelPosition: "right"
    };
  },
  components: {
    Head
  },
  mounted() {
    var that = this;
    document
      .getElementById("keydown")
      .addEventListener("keydown", that.keyDown);
  },
  methods: {
    keyDown(e) {
      if (e.keyCode === 13) {
        this.register();
      }
    },
    register() {
      let urls = window.location.origin + "/activationCode";
      this.$api.main
        .register({
          ...this.formData,
          url: urls
        })
        .then(res => {
          this.btnDisabled = false;
          if (res.status == 1) {
            this.$message.closeAll();
            this.$message.success("已发送至邮箱请注意查收");
            this.$router.push({
              path: "/orderSubmit",
              query: { type: "register" }
            });
          } else if (res.status == 0) {
            this.$message.closeAll();
            this.$message.info(res.msg);
          } else {
            this.$message.closeAll();
            this.$message.warning("已注册请激活邮箱");
          }
        });
    },
    // cascaderDistrict(node,resolve){
    //     const { level } = node;
    //     const { data } = node;
    //     let parentCode = data ? data.value : "0";
    //     this.$api.address.district({
    //         code:parentCode
    //       }).then(res=>{
    //           const nodes = res.data
    //           .map(item => ({
    //               value: item.adcode,
    //               label: item.name,
    //               leaf: level >= 2
    //           }));
    //           resolve(nodes);
    //       })
    //   },
      // handleChange(value) {
      //   this.formData.province_code = value[0],
      //   this.formData.city_code = value[1],
      //   this.formData.district_code = value[2]
      // },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.btnDisabled = true;
          this.register();
        } else {
          return false;
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.msg {
  font-size: 12px;
  color: #a52a2a;
}
/deep/.el-form-item__label {
  text-align: left !important;
  width: 90px !important;
}
/deep/ .el-form-item {
  margin-top: 18px;
  letter-spacing: 0px;
}
/deep/.el-cascader,.el-input{
  width:400px !important;
}
.register {
  width: 1920px;
  height: 100vh;
  position: relative;
  background: url("http://office.bioleaper.com.cn:6681/static/images/bg-login.jpg") no-repeat;
  background-size: 100% 100%;
  .register-box {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    min-height: 800px;
    width: 1200px;
    border-radius: 9px 9px 9px 9px;
    background: #fff;
    .register-head {
      width: 1200px;
      height: 117px;
    }
    .register-main {
      width: 553px;
      height: 21px;
      font-size: 16px;
      text-align: left;
      color: #333333;
      letter-spacing: 1px;
      margin-left: 300px;
      margin-top: 61px;
      form {
        width: 600px;
        height: 77px;
        background: #ffffff;
        margin-top: 11px;
        p {
          span {
            color: red;
          }
        }
      }
      .register-btn {
        width: 600px;
        height: 40px;
        background: #ffbb00;
        color: #003871;
        margin-top: 64px;
      }
      button {
        border: 0px;
      }
      .bottom-text {
        display: flex;
        margin-left: 79px;
        p {
          height: 16px;
          margin-top: 20px;
          margin-left: 7px;
          font-size: 12px;
          color: #333333;
          letter-spacing: 1px;
          span {
            color: #ffbb00;
          }
        }
      }
    }
  }
}
</style>